import { useCallback, useEffect, useState } from "react";

// Persisted view density for desktop DMS pages.
// Values: "normal" | "compact" | "dense" | "auto"
// The attribute is also bootstrapped in public/index.html before React mounts
// to avoid layout flicker on initial load.

const STORAGE_KEY = "dmsViewDensity";
const VALID = ["normal", "compact", "dense", "auto"];

function readInitial() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && VALID.includes(v)) return v;
  } catch (_) {}
  return "normal";
}

function applyToDom(value) {
  try {
    document.documentElement.setAttribute("data-density", value);
  } catch (_) {}
}

export default function useViewDensity() {
  const [density, setDensityState] = useState(readInitial);

  useEffect(() => {
    applyToDom(density);
  }, [density]);

  // Sync across tabs/windows.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue && VALID.includes(e.newValue)) {
        setDensityState(e.newValue);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const setDensity = useCallback((value) => {
    if (!VALID.includes(value)) return;
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (_) {}
    applyToDom(value);
    setDensityState(value);
  }, []);

  return { density, setDensity, options: VALID };
}
